import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import AdminApp from './admin/AdminApp';
import AffiliatePortalApp from './affiliate-portal/AffiliatePortalApp';
import SignupPortalApp from './signup-portal/SignupPortalApp';
import './index.css';

// Routing:
//   signup.*    → SignupPortalApp
//   affiliate.* → AffiliatePortalApp
//   admin.*     → AdminApp (subdomain — new clean URL)
//   /admin      → AdminApp (legacy path — kept for backward compat with bookmarks)
//   else        → main App
const hostname = window.location.hostname;
const isSignupPortal = hostname.startsWith('signup.');
const isAffiliatePortal = hostname.startsWith('affiliate.');
const isAdminSubdomain = hostname.startsWith('admin.');
const isAdminRoute = isAdminSubdomain || window.location.pathname.startsWith('/admin');

function chooseRoot() {
  if (isSignupPortal) return <SignupPortalApp />;
  if (isAffiliatePortal) return <AffiliatePortalApp />;
  if (isAdminRoute) return <AdminApp />;
  return <App />;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>{chooseRoot()}</React.StrictMode>,
);
